import React from 'react';

export const Download = ({ color = '#F8F8FD' }: { color: string }) => (
  <svg width="100%" height="100%" viewBox="0 0 57 57" fill="none">
    <path d="M17 24.647L28 35.647L39 24.647" stroke={color} strokeWidth="2" />
    <path d="M28 35.022V16.022" stroke={color} strokeWidth="2" />
    <path d="M16 41.647L40 41.647" stroke={color} strokeWidth="2" />
  </svg>
);
